import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import WaitingPatient from '../components/doctors/partials/waitingPatient';
import Footer from '../components/doctors/partials/Footer.js';
import '../style.scss';
import { useLocation } from 'react-router-dom';

const DoctorLayout = ({ children }) => {
  const [waitingPatientsCount, setWaitingPatientsCount] = useState(0);
  const location = useLocation();
  const pathName = location?.pathname?.substring(1);

  return (
    <div>
      <ToastContainer autoClose={900} />
      <div id="wrapper">
        {/* <Sidebar /> */}
        {pathName !== 'pdf-prescription' &&
          pathName !== 'pdf-prescription-by-scan' && (
            <WaitingPatient
              setWaitingPatientsCount={setWaitingPatientsCount}
              waitingPatientsCount={waitingPatientsCount}
            />
          )}
        <div id="content-wrapper" className="d-flex flex-column">
          <div
            id="content"
            className={waitingPatientsCount === 0 && 'no-appointment'}
          >
            {/* <Header /> */}
            {children}
          </div>
          <Footer />
        </div>
      </div>

      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
      <div
        className="modal fade"
        id="logoutModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Ready to Leave?
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              Select "Logout" below if you are ready to end your current
              session.
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                type="button"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <a className="btn btn-primary" href="login.html">
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorLayout;
